// hooks/useUserById.js
import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const fetchUserById = async (userId, getAccessTokenSilently) => {
  const apiUrl = process.env.REACT_APP_API_URL; // Your API base URL
  const token = await getAccessTokenSilently();

  const { data } = await axios.get(`${apiUrl}/api/users/${userId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return data;
};

export const useUserById = (userId) => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery(
    ["user", userId],
    () => fetchUserById(userId, getAccessTokenSilently),
    {
      // The query will not execute until the userId is truthy
      enabled: !!userId,
    }
  );
};
